<template>
  <v-alert
    color="primary"
    icon="mdi-information"
    dark
    border="right"
    elevation="5"
    class="mb-4 text-right rounded-lg"
    dir="rtl"
  >
    <v-row align="center">
      <v-col class="grow">
        <div class="text-subtitle-1 mb-1">وضعیت آپلود سنتر شما:</div>
        <div>
          تعداد فایل مجاز باقی‌مانده:
          <strong v-if="!loading"
            >{{ persian(remaining) }} از {{ persian(total) }}</strong
          >
          <v-progress-circular
            v-else
            indeterminate
            size="16"
            width="2"
            color="white"
            class="mr-2"
          ></v-progress-circular>
        </div>
        <div class="text-caption mt-1 amber--text text--lighten-2">
          * محدودیت حجم: <strong>عکس‌ها حداکثر ۵ مگابایت</strong> و
          <strong>سایر فایل‌ها حداکثر ۵۰ مگابایت</strong>
          <br />
          * محدودیت تعداد: <strong>آپلود همزمان حداکثر ۲۰ فایل</strong>
        </div>
      </v-col>
      <v-col class="shrink d-flex align-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="error"
              class="ml-2"
              @click="confirmDeleteAll"
              :loading="deleteLoading"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-delete-sweep</v-icon>
            </v-btn>
          </template>
          <span>آزاد سازی کل فضای آپلودسنتر من</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="getRemainingFiles"
              :loading="loading"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>به‌روزرسانی وضعیت</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: "UploadStatusCard",
  data() {
    return {
      remaining: 0,
      total: 1000,
      loading: false,
      deleteLoading: false,
    };
  },
  mounted() {
    this.getRemainingFiles();
  },
  methods: {
    getRemainingFiles() {
      this.loading = true;
      this.$api
        .get(`${this.$robotApi}/files/remaining`)
        .then((response) => {
          const data = response.data || response;
          this.remaining = data.remaining;
        })
        .catch(() => {
          this.$toast.error(
            "خطا در دریافت اطلاعات حجم باقیمانده آپلود سنتر شما",
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async confirmDeleteAll() {
      const isConfirmed = await this.$modal.yesNo(
        "آیا از پاکسازی کامل فضای آپلود سنتر خود اطمینان دارید؟ تمامی فایل‌ها حذف خواهند شد و این عمل غیرقابل بازگشت است.",
      );

      if (isConfirmed) {
        this.deleteAllFiles();
      }
    },

    deleteAllFiles() {
      this.deleteLoading = true;
      this.$api
        .delete(`${this.$robotApi}/files/removeAll`)
        .then(() => {
          this.$toast.success(
            "پاک سازی آپلودسنتر شما طی یک دقیقه تکمیل خواهد شد. ",
          );
          this.getRemainingFiles();
        })
        .catch(() => {
          this.$toast.error("خطا در پاکسازی آپلود سنتر.");
        })
        .finally(() => {
          this.deleteLoading = false;
        });
    },
  },
};
</script>
